export default () => ({
  dateColumn: {
    width: '15%',
  },
});
